import { Button, Card, CheckmarkIcon, Spacer, Title } from 'internalLibrary';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from './NewPasswordSet.module.scss';

const NewPasswordSet = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const gotItClicked = () => {
    navigate('/');
  };

  return (
    <div className={styles.content}>
      <Card className={styles.main}>
        <Spacer marginHorizontal="110px" marginTop="70px" marginBottom="90px">
          <Spacer marginBottom="74px">
            <Title
              text={t('passwordChanged_title')}
              icon={<CheckmarkIcon />}
              forceColumn
            />
          </Spacer>
          <Button
            onClick={gotItClicked}
            className={classNames(styles.center, styles.button)}
            fill
          >
            {t('passwordChanged_gotIt')}
          </Button>
        </Spacer>
      </Card>
    </div>
  );
};

export default NewPasswordSet;
